import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import { SxProps, useTheme } from '@mui/material/styles';
import { keyframes } from '@emotion/react';
import { useState } from 'react';

export const BOUNCE_REJECT_ANIMATION = keyframes`
  from, to { transform: scale(1) }
  50% { transform: scale(1.08) }
  `;

export type DialogCenteredProps = DialogProps & {
  innerSx?: SxProps;
  showCloseIcon?: boolean;
  onClose?: () => void;
  contentSx?: SxProps;
  preventBackdropClick?: boolean;
};

export const DialogCentered = (props: DialogCenteredProps) => {
  const {
    children,
    innerSx,
    showCloseIcon = false,
    onClose,
    contentSx,
    preventBackdropClick = false,
  } = props;
  const theme = useTheme();
  const [shouldAnimate, setShouldAnimate] = useState<boolean>(false);

  // eslint-disable-next-line @blumintinc/blumint/extract-global-constants
  const closeDialog = (_, reason) => {
    if (reason === 'backdropClick' && preventBackdropClick) {
      return setShouldAnimate(true);
    } else {
      onClose?.();
    }
  };

  return (
    <Dialog
      {...props}
      onClose={closeDialog}
      sx={{
        animation: shouldAnimate ? `${BOUNCE_REJECT_ANIMATION} .4s` : 'none',
      }}
      onAnimationEnd={() => {
        return setShouldAnimate(false);
      }}
    >
      <DialogContent
        sx={{
          position: 'relative',
          ...contentSx,
        }}
      >
        {showCloseIcon && (
          <Box
            sx={{
              position: 'absolute',
              pt: 1,
              pr: 1,
              top: 0,
            }}
          >
            <IconButton onClick={onClose}>
              <CancelIcon sx={{ color: theme.palette.primary.mid }} />
            </IconButton>
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            p: 8,

            ...innerSx,
          }}
        >
          {children}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
